import { editWorkflowEntryPoint } from '@jira/admin-pages__edit-workflow/src/editWorkflowEntryPoint.tsx';
import { workflowUserPreferencesResource } from '@atlassian/jira-router-resources-admin-pages-user-preferences/src/index.tsx';
import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { createChromelessEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { globalSettingsLayout } from '@atlassian/jira-global-settings-layout/src/index.tsx';
import { chromelessLayout } from '@atlassian/jira-chromeless-layout/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarGlobalSettingsIssues from '@atlassian/jira-navigation-apps-sidebar-global-settings-issues/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@atlassian/jira-router-resources-navigation-sidebar-global/src/index.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { globalSettingsIssueWorkflowEditRoute } from '@atlassian/jira-router-routes-admin-pages-workflows-routes/src/globalSettingsIssueWorkflowEditRoute.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@atlassian/jira-router-resources-post-office/src/services/index.tsx';
import Spinner from '@atlassian/jira-common-components-spinner/src/view.tsx';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import { workflowCapabilitiesResource } from '@atlassian/jira-router-resources-admin-pages-workflow-capabilities/src/index.tsx';
import { workflowDocumentResource } from '@atlassian/jira-router-resources-admin-pages-workflow-document/src/index.tsx';
import { jiraSpaResources } from '@atlassian/jira-router-resources-spa-page-container/src/index.tsx';
import { workflowBuilderProvisioningResource } from '@atlassian/jira-router-resources-admin-pages-workflow-builder-provisioning/src/index.tsx';
import { rovoEntitlementResource } from '@atlassian/jira-router-resources-rovo-entitlement/src/services/index.tsx';
import { projectWorkflowContextResource } from '@atlassian/jira-router-resources-project-workflow-context/src/services/project-workflow-context/index.tsx';
import EditWorkflow, {
	LazyEditWorkflow,
} from './ui/spa/admin-pages/workflows/edit-workflow/index.tsx';

const globalSettingsIssueWorkflowEditEntryPoint = createChromelessEntryPoint({
	main: editWorkflowEntryPoint,
});

const getWorkflowBuilderProvisioningResources = () => [workflowBuilderProvisioningResource];

export const globalSettingsIssueWorkflowEditRouteEntry = createEntry(
	globalSettingsIssueWorkflowEditRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'global-admin.issues.edit-workflow',

		entryPoint: () =>
			expValEquals('hix-6586_wfe_no_nav_or_sidebar_route', 'isEnabled', true, false)
				? globalSettingsIssueWorkflowEditEntryPoint
				: undefined,

		skeleton: expValEquals('hix-6586_wfe_no_nav_or_sidebar_route', 'isEnabled', true, false)
			? Spinner
			: undefined,

		component: expValEquals('hix-6586_wfe_no_nav_or_sidebar_route', 'isEnabled', true, false)
			? undefined
			: EditWorkflow,

		layout: expValEquals('hix-6586_wfe_no_nav_or_sidebar_route', 'isEnabled', true, false)
			? chromelessLayout
			: globalSettingsLayout,

		navigation: expValEquals('hix-6586_wfe_no_nav_or_sidebar_route', 'isEnabled', true, false)
			? undefined
			: {
					sidebarId: SIDEBAR_ID.GLOBAL_ISSUES_SETTINGS,
					menuId: MENU_ID.SETTINGS,
					sidebar: AsyncSidebarGlobalSettingsIssues,
				},

		resources: expValEquals('hix-6586_wfe_no_nav_or_sidebar_route', 'isEnabled', true, false)
			? [
					projectWorkflowContextResource,
					workflowCapabilitiesResource,
					workflowDocumentResource,
					...jiraSpaResources(),
					rovoEntitlementResource,
					workflowUserPreferencesResource,
					...getWorkflowBuilderProvisioningResources(),
				]
			: [
					...getNavigationResources(),
					...getWorkflowBuilderProvisioningResources(),
					navigationSidebarGlobalResource,
					conditionalPostOfficeJiraTopBannerResource,
				],

		forPaint: expValEquals('hix-6586_wfe_no_nav_or_sidebar_route', 'isEnabled', true, false)
			? undefined
			: [LazyAtlassianNavigation, LazyEditWorkflow],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-admin-pages-workflows-entries/src/globalSettingsIssueWorkflowEditRouteEntry.tsx',
				whichExportToUse: 'globalSettingsIssueWorkflowEditRouteEntry',
			},

			enabled: true,
		},
	}),
);
